export const LOGIN_ROUTE = "/login";
export const OAUTH_CALLBACK_ROUTE = "/auth/callback";
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const TERMS_AND_CONDITONS_ROUTE = "/terms-and-conditions";
export const RESET_PASSWORD_ROUTE = "/reset-password";
export const REGISTER_SUCCESS = "/register-success";
export const REGISTER_ROUTE = "/register";
export const REGISTER_VERIFICATION_PROCESS_ROUTE =
  REGISTER_ROUTE + "/verification-process";
export const REGISTRATION_VERIFICATION_ROUTE = REGISTER_ROUTE + "/verification";
export const HOME_ROUTE = "/home";
export const HOUSE_MANAGER = "/house-manager"
export const HOME_ADDRESS_ROUTE = HOME_ROUTE + "/address";
export const SUPPORT_ROUTE = "/support";
export const BILL_ARCHIVE = HOME_ADDRESS_ROUTE + "/billarchive";
export const BILLS = "/bills";
export const USER_PROFILE = "/user-profile";
export const NEWS = "/news";
export const PROJECTS_AND_REPAIR_WORKS = "/projects-and-repair-works";
export const HOUSES_INFO_ROUTE = HOME_ADDRESS_ROUTE + "/houses-info";